import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {SlideDown} from 'react-slidedown'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon,
} from '../../components'
import Styles from './IyvListCart.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListCart extends Component {
  static propTypes = {
    cart: PropTypes.object,
    resetCart: PropTypes.func,
    cartChange: PropTypes.func,
    clickCompareSelect: PropTypes.func,
  }
  //
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  //
  constructor(props) {
    super(props)
  }
  //
  countEmptySlots = (cart) => {
    let emptyCount = 0
    for (let i = 0; i < cart.length; i++) {
      if (
        cart[i].id === 'N' ||
        !cart[i].id
      ) {
        emptyCount += 1
      }
    }
    return emptyCount
  }
  //
  clickAnalyzeCompare = () => {
    // if we have empty slots and but not all empty slots
    const emptySlots = this.countEmptySlots(this.props.cart.results)
    if (emptySlots < 3) {
      // manually build a query string (should do this differently)
      let url = config.routes.compare + '?'
      this.props.cart.results.forEach(
        (slot, slotIdx) => {
          if (slot.id !== 'N') {
            url += 's' + (slotIdx + 1).toString() + '=' + slot.id + '&'
          }
        }
      )
      this.context.router.push(url)
    }
  }
  //
  render() {
    if (
      this.props.cart &&
      this.props.cart.results &&
      this.props.cart.results.length
    ) {
      const emptyCount = this.countEmptySlots(this.props.cart.results)
      return (
        <div styleName='hidden-xs'>
          <SlideDown>
            { /* if every slot is empty, hide it */
              emptyCount < this.props.cart.results.length ?
                <div styleName='cart-fixed'>
                  <div styleName='cart-clear-wrap'>
                    <div styleName='cart-clear-label'>
                      Selected funds
                    </div>
                    <div
                      styleName='cart-clear-btn'
                      onClick={this.props.resetCart}
                    >
                      Clear list
                    </div>
                  </div>
                  { /* render a slot or an empty slot */
                    this.props.cart.results.map((slot, slotIndex) => {
                      if (slot.id !== 'N' && slot.shareclassStub) {
                        const {
                            name,
                            ticker,
                            fund_id,
                            investment_vehicle_id,
                            fund_legal_name
                          } = slot.shareclassStub
                        const sTicker = ticker || 'N'

                        const url =
                          config.routes.fund + '/' +
                          format.sanitize(fund_legal_name) + '/' +
                          sTicker + '/' + config.profilePath + '/' +
                          fund_id + '/' +
                          investment_vehicle_id

                        return <div
                          styleName='cart-slot'
                          key={'cart-slot-'+slotIndex}
                        >
                          <div styleName='cart-slot-filled'>
                            <div styleName='cart-slot-title-clear'>
                              <div
                                styleName='cart-slot-clear'
                                onClick={
                                  () => {
                                    this.props.clickCompareSelect(
                                      slot.shareclassStub
                                    )
                                  }
                                }
                              >
                                <LinkIcon nospace faclass='fa-trash'/>
                              </div>
                              <div styleName='cart-slot-title'>
                                {name}
                              </div>
                            </div>
                            <div styleName='cart-slot-subtitle'>
                              {ticker || ''}
                              &nbsp;
                              <Link
                                to={url}
                                title={name + ' | ' + config.app.title}
                                xstrong
                              >
                                Profile
                              </Link>
                            </div>
                          </div>
                        </div>
                      } else {
                        return <div
                          styleName='cart-slot'
                          key={'cart-slot-' + slotIndex}
                        />
                      }
                    })
                  }
                  <div
                    styleName={
                      this.countEmptySlots(this.props.cart.results) > 2 ?
                        'cart-submit-disabled' :
                        'cart-submit'
                    }
                    onClick={this.clickAnalyzeCompare}
                  >
                    Compare<LinkIcon/>
                  </div>
                </div> :
                null
            }
          </SlideDown>
        </div>
      )
    }
    return null
  }
}

